/* eslint-disable func-names */
<template>
  <div class="topicThree">
    <canvas width="500" height="500" ref="qtchess" style="width:100%;"></canvas>
    <div class="button" @click="confirmAns">确定</div>
  </div>
</template>

<script>
import Island from '../lib/island';

export default {
  name: 'topicThree',
  props: {
    question: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: { },
    },
    reload: {
      type: Number,
    },
  },
  computed: {
    tips() {
      const str = this.question.answer;
      return str.substr(1, str.length - 2).split('][');
    },
  },
  watch: {
    reload() {
      this.initZT();
    },
  },
  mounted() {
    this.initZT();
  },
  methods: {
    initZT() {
      const { Practice } = Island;
      console.log(this.question);
      // eslint-disable-next-line no-new
      if (this.qt) this.qt.off();
      this.qt = new Practice({
        $el: this.$refs.qtchess, // canvas对象
        width: 500, // canvas宽度
        type: this.question.t_type, // 0 执行题，1 判断题, 2 单选题，3 其他类型
        content: this.question.ask_desc, // 内容
      });
    },
    // 获取答案正确与否
    confirmAns() {
      // eslint-disable-next-line camelcase
      let stu_ans = this.qt.getSelected();
      // 答案统一做大写处理
      stu_ans = stu_ans.map(v => v.toUpperCase());
      if (this.judgeArr(stu_ans, this.tips)) {
        this.$emit('getResult_qt', '正确');
      } else {
        this.$emit('getResult_qt', '错误');
      }
    },
    // 对比答案数据
    // eslint-disable-next-line camelcase
    judgeArr(stu_ans, ans) {
      console.log(stu_ans, ans);
      if (stu_ans.length === ans.length) {
        return ans.every(v => stu_ans.includes(v.toUpperCase()));
      }
      return false;
    },
  },
};
</script>
<style scoped lang="scss">
  .topicThree{
    width: 100%;
    height:100%;
    .answers{
      width:halvePx(670);
      display: flex;
      align-items: center;
      justify-content: center;
      margin:0 auto;
      margin-top:halvePx(86);
      img{
        display:inline-block;
        width:halvePx(44);
        height:halvePx(60);
      }
      .answers-choose{
        height:auto;
        .choose-item{
          width:halvePx(540);
          height:halvePx(100);
          background:rgba(250,229,179,1);
          border:halvePx(2) solid rgba(196, 178, 135, 1);
          border-radius:halvePx(50);
          margin:auto;
          font-size:halvePx(30);
          font-family:PingFang-SC-Regular;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:halvePx(100);
          text-align: center;
          margin:halvePx(20);
        }
      }
    }
    .button{
      width:halvePx(200);
      height:halvePx(100);
      line-height: halvePx(100);
      text-align: center;
      background:rgba(250,229,179,1);
      border:halvePx(2) solid rgba(196, 178, 135, 1);
      border-radius:halvePx(50);
      margin:halvePx(20) auto;
      font-size:halvePx(30);
      font-family:PingFang-SC-Regular;
      font-weight:400;
      color:rgba(51,51,51,1);
    }
  }
</style>
